<template>
  <div class="student-list">
    <!-- <el-dialog
      title="宿舍学生列表"
      :visible="movedStudentListShow"
      width="50%"
      @close="dialogClose"
    >
      
    </el-dialog> -->
    <el-table :data="studentListByDorm" style="width: 100%; display: inline-block;">
      <el-table-column prop="studentName" label="姓名">
      </el-table-column>
      <el-table-column prop="sex" label="性别">
      </el-table-column>
      <el-table-column prop="studentNumber" label="学号">
      </el-table-column>
      <el-table-column prop="gradeName" label="年级"></el-table-column>
      <el-table-column prop="className" label="班级"></el-table-column>
      <el-table-column label="操作" width="120px">
        <template slot-scope="scope">
          <div class="handle-container">
            <el-button size="mini" type="danger" @click="retreat(scope.row)">退宿</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "",
  props: ["movedStudentListShow", "studentListByDorm"],
  data() {
    return {};
  },
  methods: {
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:movedStudentListShow", false);
    },
    retreat(data) {
      this.$emit("retreat", data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./movedStudentList.scss";
</style>